import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface Disciplina {
  id: string;
  designacao: string;
}
@Injectable({
  providedIn: 'root'
})
export class DisciplinaService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all Disciplinas
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: Disciplina[] }>(`${this.path}/getAllDisciplina`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  // Get Disciplina by ID
  public show(id: string): Observable<Disciplina> {
    return this.apiService.get<{ object: Disciplina }>(`${this.path}/getDisciplinaById/${id}`).pipe(
      map(response => response.object as Disciplina)
    );
  }

  // Create new Disciplina
  public store(disciplina: Disciplina): Observable<Disciplina> {
    return this.apiService
      .post<{ object: Disciplina }>(`${this.path}/AddDisciplina`, disciplina)
      .pipe(
        map((response) => response.object as Disciplina)
      );
  }

  public storeDisciplinaPlanoCurricular(disciplina: Disciplina): Observable<Disciplina> {
    return this.apiService
      .post<{ object: Disciplina }>(`${this.path}/AddDisciplinaInPlanoCurricular`, disciplina)
      .pipe(
        map((response) => response.object as Disciplina)
      );
  }

  // Update existing Disciplina
  public update(disciplina: Disciplina): Observable<Disciplina> {
    return this.apiService
      .put<{ object: Disciplina }>(`${this.path}/UpdateDisciplina`, disciplina)
      .pipe(
        map((response) => response.object as Disciplina)
      );
  }

  // Delete existing Disciplina
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteDisciplinaById/${id}`);
  }
}
